import { ConversationCapability } from './conversationCapability';

// const smsFeatureFlag = 'integrations.messaging.beta';

export class DummyConversationCapability implements ConversationCapability {
  async isCapableForConversation(_: string): Promise<boolean> {
    return Promise.resolve(true);
  }
}
